<template>
  <div class="content">
    <div class="container-fluid">
      <div class="alert alert-danger" v-if="alertPhone">Cadastre seu telefone.</div>
      <div class="alert alert-danger" v-if="alertBirthday" >Cadastre sua data de nascimento.</div>
      <div class="alert alert-danger" v-if="alertAddress">Cadastre seu endereço.</div>      

      <article class="card">
        <form @submit.prevent="save">
          <div class="card-body p-5 text-center">
            <div class="row form-group">
              <div class="col-md-12">
                <label>Nome:</label>
                <input type="text" :value="user.name" class="form-control" disabled />
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-6">
                <label>CPF:</label>
                <input
                  @change="saveUser=true"
                  v-mask="'###.###.###-##'"
                  type="text"
                  v-model="user.cpf"
                  class="form-control"
                  :disabled="disableCpf"
                />
              </div>
              <div class="col-md-6">
                <label>CNH:</label>
                <input 
                  v-mask="'###########'"
                  @change="saveUser=true"
                  type="text" 
                  v-model="user.drive_license" 
                  class="form-control" 
                  :disabled="disableCnh" 
                />
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-6">
                <label>Telefone:</label>
                <input
                  v-mask="'(##)#####-####'"
                  type="text"
                  v-model="user.phone"
                  @change="saveUser = true"
                  class="form-control"
                  required
                />
              </div>
              <div class="col-md-6">
                <!-- <label>Data de Nascimento:</label>
                <input
                  type="date"
                  v-model="user.birthday"
                  @input="saveUser = true"
                  class="form-control"
                  max="9999-12-31"
                  required
                /> -->
                <v-spacer></v-spacer>
                <v-flex xs12 sm6 md4>
                  <v-menu
                    ref="birthdayMenu"
                    v-model="birthdayMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="user.birthday"
                        label="Data de nascimento"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker"
                      v-model="user.birthday"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @change="birthdayMenu=false;saveUser=true"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </div>
            </div>
            <div class="row form-group" v-show="!newEmailShow">
              <div class="col-md-12">
                <label>E-mail:</label>
                <div style="position: relative;">
                  <input
                    type="email"
                    :value="user.email"
                    class="form-control"
                    id="editEmail"
                    ref="currentEmail"
                    disabled
                  />
                  <!-- POR ALGUM MOTIVO, ESTE BOTÃO ESTÁ DISPARANDO O FORM. USEI O PREVENT PARA ELE NÃO FAZER MAIS ISSO -->
                  <button
                    @click.prevent="newEmailForm"
                    ref="editEmailBtn"
                    style="position:absolute;right:10px;top:50%;transform:translate(0,-50%);padding: 2px 7px;font-size:12px;cursor:pointer;"
                    class="btn c-secondary"
                  >editar</button>
                </div>
              </div>
            </div>
            <div class="row form-group" v-show="newEmailShow">
              <div class="col-md-12">
                <label>Novo E-mail:</label>
                <input type="email" v-model="newEmail" class="form-control" ref="newEmail" />
              </div>
            </div>
            <div class="row form-group" v-show="newEmailShow">
              <div class="col-md-12">
                <label>Confirmar E-mail:</label>
                <input
                  type="email"
                  v-model="confirmEmail"
                  class="form-control"
                  id="confirmEmail"
                  ref="confirmEmail"
                />
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12">
                <label for="password" v-show="!newPwdShow">Senha:</label>
                <label for="password" v-show="newPwdShow">Nova Senha:</label>
                <div style="position: relative;" v-show="!newPwdShow">
                  <input
                    id="changePwd"
                    type="password"
                    class="form-control"
                    ref="currentPwd"
                    value="pickndrive123"
                    disabled
                  />
                  <!-- POR ALGUM MOTIVO, ESTE BOTÃO ESTÁ DISPARANDO O FORM. USEI O PREVENT PARA ELE NÃO FAZER MAIS ISSO -->
                  <button
                    @click.prevent="newPasswordForm()"
                    ref="editPwdBtn"
                    style="position:absolute;right:10px;top:50%;transform:translate(0,-50%);padding: 2px 7px;font-size:12px;cursor:pointer;"
                    class="btn c-secondary"
                  >editar</button>
                </div>
                <input type="password" v-show="newPwdShow" v-model="newPwd" class="form-control" />
              </div>
            </div>
            <div class="row form-group" v-show="newPwdShow">
              <div class="col-md-12">
                <label for="password">Confirmar Senha:</label>
                <input id="password" type="password" v-model="confirmPwd" class="form-control" />
              </div>
            </div>
            <hr />
            <h6 ref="#address" id="address" class="text-center">Endereço</h6>
            <hr />
            <div class="row form-group text-center">
              <div class="col-md-12">
                <app-address :address="address"></app-address>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12">
                <button @click="save" type="button" class="btn save btn-block">Salvar</button>
              </div>
            </div>
          </div>
        </form>        
      </article>
    </div>
  </div>
</template>

<script>
import AuthController from "./../../controllers/AuthController.js";
import UserController from "./../../controllers/UserController.js";
import User from "./../../models/User.js";
import AddressController from "./../../controllers/AddressController.js";
import Address from "./../../models/Address.js";
import AddressC from "../shared/Address.vue";
import { isNull } from "util";
import Configuration from "../../controllers/ConfigurationController.js";
import Constants from "../../models/constants/Constants.js";
import DateHelper from "../../helpers/DateHelper.js";
import moment from "moment";

export default {
  data() {
    return {
      authController: new AuthController(
        this.$resource,
        this.$router,
        this.$message
      ),
      userController: new UserController(this.$resource),
      user: new User(),
      addressController: new AddressController(this.$resource),
      address: new Address(),
      configurationController: new Configuration(this.$resource),
      newPwdShow: false,
      newEmailShow: false,
      newPwd: null,
      confirmPwd: null,
      newEmail: null,
      confirmEmail: null,
      saveUser: false,
      saveAlterAddress: false,
      alertAddress: false,
      alertCard: false,
      alertPhone: false,
      alertBirthday: false,
      paymentOnRequest: true,
      configurations: {},
      disableCnh: true,
      disableCpf: true,
      birthdayMenu: false
    };
  },

  async created() {
    await this.getUser().then(() => this.getAddress());
    this.getConfigurations();
    this.alertCard = this.$route.query.card;
    this.user.cpf?this.disableCpf=true:this.disableCpf=false
    this.user.drive_license?this.disableCnh=true:this.disableCnh=false
  },

  computed: {
    handlerInputEmail(event) {
      this.abc = event;
      return event;
    }
  },
  watch: {
    birthdayMenu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  methods: {
    updateAlertCard($event) {
      this.alertCard = $event;
    },
    getUser() {
      return new Promise((resolve, reject) => {
        try {
          this.userController.getUserData().then(res => {
            resolve((this.user = res));
            this.user = res.user;

            if (!this.user.phone) {
              this.alertPhone = true
            }

            if (!this.user.birthday) {
              this.alertBirthday = true
            }

            if (!this.user.id_address){
              this.alertAddress = true
            }

            if (this.user.birthday) {
              this.user.birthday = moment(this.user.birthday)
                .utc()
                .format("YYYY-MM-DD");
            }

            this.getConfigurations();
          });
        } catch (error) {
          reject(this.$awn.alert(error.body.message));
          this.$awn.alert(error.body.message);
        }
      });
    },
    newPasswordForm() {
      this.newPwdShow = true;
    },

    newEmailForm() {
      this.newEmailShow = true;
    },

    async save() {
      if (this.newPwd != null) {
        if (this.newPwd == this.confirmPwd) {
          await this.authController.changePassword(this.newPwd).then(() => {
            this.$message({
              type: "success",
              message: "Senha alterada com sucesso!"
            });
            this.newPwdShow = false;
          });
        } else {
          this.$message.error("A confirmação de senha não está correta.");
        }
      }

      if (this.newEmail != null) {
        if (this.newEmail == this.confirmEmail) {
          await this.authController.changeEmail(this.newEmail).then(() =>
            this.$message({
              type: "success",
              message: "Enviamos um e-mail para confirmar a alteração!"
            })
          );
        } else {
          this.$message.error("A confirmação do e-mail não está correta.");
        }
      }

      if (this.saveUser === true) {
        await this.userController.partialUpdate(this.user).then(() =>
          this.$message({
            type: "success",
            message: "Dados Atualizados!"
          })
        );
      }

      await this.saveAddress();
      this.alertAddress = false;
      setTimeout(()=>{
        window.location.reload()
      },1000)
      
    },

    getAddress() {
      try {
        if (!this.user.id_address) {
          throw "Endereço não cadastrado";
        }

        this.addressController
          .getAddressById(this.user.id_address)
          .then(res => {
            this.address = res;
          });
      } catch (error) {
        console.log(error);
      }
    },

    async saveAddress() {
      try {
        let id_address;
        if (this.user.id_address == null) {
          await this.addressController.create(this.address).then(res => {
            id_address = res.id_address;
            this.userController.setAddress({ id_address: id_address });
            // location.reload();
          });
        } else {
          await this.addressController
            .update(this.user.id_address, this.address)
            .then(res => {
              // location.reload();
            });
        }

        this.$message({
          type: "success",
          message: "Registro salvo com sucesso"
        });

        this.getUser();
      } catch (e) {
        this.$awn.alert("Erro ao salvar Endereço");
      }
    },

    async getConfigurations() {
      let configs = await this.configurationController.getAll();
      this.configurations = configs;
      if (configs.vehicle_request_type === 'rent') {
        this.paymentOnRequest = true;
      }
    }
  },

  components: {
    "app-address": AddressC,
  }
};
</script>
<style lang="scss" scoped>
.btn.save {
  background-color: var(--primary-color);
  color: #222
}

.c-secondary {
  background-color: var(--secondary-color);
  color: #FFF;
  max-width: 25%;
}
</style>